import React from "react";
import { roundMoneyValue } from "../../../../utils/functions";
import { getDietType, getItemPriceByQuantity, getActualMealTypeQuantity } from "./../utils/functions";

function MealsElements(props) {
  const { dietType, programType, limitations, selectedMeals, bundles } = props;
  const breakfastsMinLimit = limitations.breakfastsMinLimit;
  const entreesMinLimit = limitations.entreesMinLimit;
  const breakfastType = getDietType("Breakfasts", dietType);
  const entreesType = getDietType("Entrées", dietType);
  const actualBreakfastsQuantity = getActualMealTypeQuantity(limitations, breakfastType, selectedMeals);
  const actualEntreesQuantity = getActualMealTypeQuantity(limitations, entreesType, selectedMeals);

  const computeMealsPrice = () => {
    let _breakfastPrice = 0;
    let _entreePrice = 0;
    _breakfastPrice = getItemPriceByQuantity(actualBreakfastsQuantity, breakfastType, bundles);
    _entreePrice = getItemPriceByQuantity(actualEntreesQuantity, entreesType, bundles)

    if (programType === "Meals") {
      return roundMoneyValue(_breakfastPrice * actualBreakfastsQuantity + _entreePrice * actualEntreesQuantity);
    } else {
      return roundMoneyValue(_breakfastPrice * breakfastsMinLimit + _entreePrice * entreesMinLimit);
    }
  };


  const getDietTypeLabels = (type) => {

  switch (type) {
  case "Mediterranean Plan":
    return {
      dietTypeTitle: "Mediterranean",
      programTitle: "Mediterranean Meals",
    };
  case "Low-FODMAP Plan":
    return {
      dietTypeTitle: "Low-FODMAP",
      programTitle: "Low FODMAP Meals",
    };
  case "Diabetes Plan":
    return {
      dietTypeTitle: "Diabetes-Friendly",
      programTitle: "Diabetes-Friendly Meals",
    };
  case "Gluten-Free Plan":
    return {
      dietTypeTitle: "Gluten-Free",
      programTitle: "Gluten-Free Meals",
    };
  case "Heart-Friendly Plan":
    return {
      dietTypeTitle: "Heart-Friendly",
      programTitle: "Heart-Friendly Meals",
    };
  case "Carb-Conscious Plan":
    return {
      dietTypeTitle: "Carb-Conscious",
      programTitle: "Carb-Conscious Meals",
    };
  case "B2B Plan":
    return {
      dietTypeTitle: "B2B",
      programTitle: "B2B Meals",
    };
  case "Care Plan":
    return {
      dietTypeTitle: "Care",
      programTitle: "Care Meals",
    };
  case "GLP-1 Plan":
    return {
      dietTypeTitle: "GLP-1",
      programTitle: "GLP-1 Meals",
    };
    default:
      return "404";
}
}

  let mealsPrice = computeMealsPrice();

  const { dietTypeTitle, programTitle } = getDietTypeLabels(dietType);

  const mealsTitle = `${dietTypeTitle} Meals`;

  const ProgramMarkup = () => {
    return (
      <>
        <div className="product-nav__title">{programTitle}</div>
        <dl className="price">
          <div className="price__regular">
            <dd>
              <span className="price-item price-item--regular">${mealsPrice}</span>
            </dd>
          </div>
        </dl>{" "}
      </>
    );
  };
  const MealsMarkup = () => {
    return (
      <>
        {mealsPrice.length > 0 && (
          <>
            <div className="product-nav__title">{mealsTitle}</div>
            <dl className="price">
              <div className="price__regular">
                <dd>
                  <span className="price-item price-item--regular">${mealsPrice}</span>
                </dd>
              </div>
            </dl>{" "}
          </>
        )}
      </>
    );
  };

  if (programType === "Meals") return <MealsMarkup />;
  if (programType === "Program") return <ProgramMarkup />;
  if (programType === "") return null;
}

export default MealsElements;
